import { DefaultComponentDefinitions, defaultComponentDefinitions } from '@grandvision/bloomreach'

// You can extend/overwrite the default component definitions here
const componentDefinitions: DefaultComponentDefinitions = {
  ...defaultComponentDefinitions,
}

export default componentDefinitions
